<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerar DOC Associado</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('gerardocassociado.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('gerardocassociado.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('gerardocassociado.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/gerardocassociado"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="docfis_id"
                                            pagination-path=""
                                            detail-row-component="gerardocassociado-detalhes"
                                            @vuetable:cell-clicked="onDetail"
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="selecionado" slot-scope="props">
                                              <b-form-checkbox buttons
                                                               button-variant="secondary"
                                                               v-model="props.rowData.selecionado"
                                                               value="1"
                                                               unchecked-value="2">
                                              </b-form-checkbox>
                                          </template>

                                          <template slot="pessoa" slot-scope="props">
                                            <span>{{ onFormataCnpj(props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_base,props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_filial,props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_digito)}} - {{ props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.razao_social }}</span>
                                          </template>

                                          <template slot="num_uc" slot-scope="props">
                                            <span>{{props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_uc}}</span>
                                          </template>

                                          <template slot="container" slot-scope="props">
                                            <span>{{props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_container}}</span>
                                          </template>

                                          <template slot="lacre" slot-scope="props">
                                            <span>{{props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].num_lacre}}</span>
                                          </template>

                                          <template slot="status_uc" slot-scope="props">
                                                <span class="badge badge-info" v-if="props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==1">{{ props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                                <span class="badge badge-warning" v-if="props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==2">{{ props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>
                                                <span class="badge badge-success" v-if="props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==3">{{ props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}[ {{ props.rowData.carga_doc_unidade_carga[0].carga_doc.length }} ] </span>
                                                <span class="badge badge-danger" v-if="props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.valor==4">{{ props.rowData.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].status.descr }}</span>

                                            </template>

                                            <template slot="actions" slot-scope="props">
                                              <div class="custom-actions">
                                                  <a @click="onCreate(props.rowData)" v-b-tooltip title="Gerar CTE"  v-if="getPermission('pedido.update')"><i class="fa fa-file"></i></a>
                                                  <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                                </button>
                                              </div>
                                            </template>
                                      </vuetable>
                                  </div>


                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              <!-- Modal Component -->
              <b-modal id="modal_associar"
                       ref="modal_associar"
                       :title="modal_titulo"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       v-model="showModal"
                       size="lg"
                       :ok-disabled=form.errors.any()
                       @ok="handleOk">
                       <b-container fluid class="p-a-0">
                           <b-row>
                           <table class="table">
                               <thead>
                                   <tr>
                                       <th style="width: 20%">Emitente</th>
                                       <th style="width: 25%">Chave</th>
                                       <th style="width: 10%">Número Fiscal</th>
                                       <th style="width: 10%">Série</th>
                                       <th style="width: 15%">Data</th>
                                       <th style="width: 5%">Ação</th>
                                   </tr>
                                </thead>
                                <tbody>
                                    <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                       <td>
                                           {{ row.emi_nome }}
                                       </td>
                                       <td>
                                           {{ row.chave }}
                                       </td>
                                       <td>
                                           {{ row.num_fiscal }}
                                       </td>
                                       <td>
                                           {{ row.serie }}
                                       </td>
                                       <td>
                                           <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                       </td>
                                       <td>
                                           <i class="glyphicon glyphicon-remove" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                       </td>
                                   </tr>
                               </tbody>
                           </table>
                           <br/>
                           <table class="table">
                               <thead>
                                   <tr>
                                       <th style="width: 100%">Adicionar NFe</th>
                                   </tr>
                                </thead>
                                <tbody>
                                    <tr class="bg-gray-light" style="display: table-row;">
                                       <td>
                                           <b-container fluid class="p-a-0">
                                              <b-row no-gutters>
                                                 <b-col sm="11" md="11" class="m-t-5px p-a-0">
                                                     <b-form-input type="text"
                                                                   placeholder=""
                                                                   v-model="helpForm.chave"
                                                                   >
                                                     </b-form-input>
                                                     <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                 </b-col>
                                                 <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                     <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDoc($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                     Adicionar
                                                     </b-btn>
                                                 </b-col>
                                             </b-row>
                                          </b-container>
                                       </td>
                                   </tr>
                                   <tr>
                                       <td>
                                           <div class="float-left"><spinner v-if="loadingAddDoc" message="Processando..."></spinner></div>
                                       </td>
                                  </tr>
                               </tbody>
                           </table>
                      </b-row>
                  </b-container>
                  <div slot="modal-footer" class="w-100">
                         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                         <div class="float-right">
                           <div class="float-left" v-if="this.errors_array.length>0">
                           <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                           <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                             <table class="table" id="mais">
                                  <tbody>
                                      <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                         <td>
                                           {{ item.erro }}
                                         </td>
                                     </tr>
                                 </tbody>
                             </table>
                           </b-popover>
                         </div>
                         &nbsp;

                             <b-btn @click="showModal=false" variant="secondary">
                               Fechar
                             </b-btn>
                             <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                               Enviar
                             </b-btn>
                         </div>
                  </div>
              </b-modal>
      </div>
  </div>
  </template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import AssociarFilterBar from './AssociarFilterBar'
import moment from 'moment'
import {VMoney} from 'v-money'
import accounting from 'accounting'
import GerarDocAssociadoDetalhes from './GerarDocAssociadoDetalhes'

Vue.component('gerardocassociado-detalhes', GerarDocAssociadoDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': AssociarFilterBar,
        VMoney,
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          loadingAddDoc: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalAssociar: false,
          docfis: [],
          tomador: [{tomador:''}],
          errors_array: [],
          form: new Form({  num_container: '',
                           status: '',
                           num_lacre: '',
                           docfis: [],
                           tomador: '',
                       }),
         helpForm: new Form({chave:'', statusRecord: [], params: [],search:''}),
        fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: '__slot:pessoa',
            title: 'Pessoa'
          },
          {
            name: '__slot:num_uc',
            title: 'N° UC'
          },
          {
            name: '__slot:container',
            title: 'Container'
          },
          {
            name: '__slot:lacre',
            title: 'Lacre'
          },
          {
            name: '__slot:status_uc',
            title: 'Status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        percentual_advalorem: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
              'num_pedido': data_filter.num_pedido,
              'num_uc': data_filter.num_uc,
              'tom_cnpj': data_filter.tom_cnpj,
              'for_cnpj': data_filter.for_cnpj,
              'dt_inicio': data_filter.dt_inicio,
              'dt_fim': data_filter.dt_fim,
              'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
        },
        onCreate (data) {
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            //this.form.reset();
            this.form.docfis = [];
            this.form.tomador = this.onFormataCnpj(data.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_base,data.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_filial,data.carga_doc.carga_doc_unidade_carga[0].pedido_unidade_carga[0].pedido.pessoa_tomador.pessoa_juridica.cnpj_digito);
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.form.docfis.push({ id: obj })
            });console.log(this.form.tomador);
            this.$refs.modal_associar.show();
        },
        onStore() {
            this.docfis = null;
            this.docfis = [];
            this.form.tomador = this.tomador;
            this.form.docfis.forEach((docfis_id)=>{
                this.$refs.vuetable.tableData.forEach((obj)=>{
                    if(obj.docfis_id==docfis_id.id)
                    {
                        this.docfis.push({  id: obj.docfis_id,
                                            chave: obj.chave,
                                            num_fiscal: obj.num_fiscal,
                                            serie: obj.serie,
                                            dt_emissao: obj.dt_emissao,
                                            emi_nome: obj.doc_fiscal_partes_env.emi_nome })
                    }
                });
            });
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_associar.hide();
            this.form.post('/api/gerardocassociado/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        listaClientesFornecedor(search) {
          if(search.length>=3)
          {
              this.isLoadingFor = true;
              this.helpForm.search = search;
              this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
              {
                  this.optionsFornecedor = [];
                  new ReturnApi(response, this, true, false, false);
                  response.items.forEach((obj)=>
                  {
                      this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                  });
                  this.isLoadingFor = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
                });
            }
        },
        removeRowDoc: function(index) {
            this.form.splice(index, 1);
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
